const entities: Record<string, string> = {'&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', '\'': '&#39;'}

/**
 * Escapes a value for use in an HTML string (a Leaflet tooltip), so names and instructions entered by users can't
 * add markup. null and undefined give an empty string.
 */
export default function escapeHtml(value: unknown) {
    if (value === undefined || value === null) {
        return ''
    }

    return String(value).replace(/[&<>"']/g, (char) => entities[char])
}
